import React, { ReactNode } from 'react';
import { usePageTracking } from '../hooks/usePageTracking';

interface AnalyticsProviderProps {
    children: ReactNode;
}

/**
 * Component that handles automatic page view tracking
 */
const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
    usePageTracking();
    return <>{children}</>;
};

export default AnalyticsProvider;
